import { Auth } from 'aws-amplify'
import { hubSignIn, hubSignInFailure } from './sign-in'
import { datadogLogs } from '@datadog/browser-logs'
import { getSegmentId } from '../utilities/segment'

const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms))

let didPostLogin = false

export const completeAuthentication = async (maybeUser?: any) => {
  if (didPostLogin) return
  didPostLogin = true

  for (let i = 0; i < 8; i++) {
    try {
      await Auth.currentSession()
      break
    } catch {
      await sleep(125)
    }
  }

  const user =
    maybeUser || (await Auth.currentAuthenticatedUser().catch(() => null))

  if (user?.signInUserSession) {
    await hubSignIn(user)
  } else {
    datadogLogs.logger.error('Post-login failed - no user session', {
      userId: getSegmentId(),
      url: window.location.href,
      hasUser: !!user,
      hasSession: !!user?.signInUserSession,
      timestamp: new Date().toISOString(),
    })
    hubSignInFailure('No user/session after Hosted UI')
  }
}

export const resetPostLoginFlag = () => {
  didPostLogin = false
}
